import React, { createContext, useContext, useState } from 'react';
import CreateDirectoryDialog from './CreateDirectoryDialog';

const CreateDirectoryDialogContext = createContext();
export const useCreateDirectoryDialog = () => useContext(CreateDirectoryDialogContext);

function CreateDirectoryDialogProvider(props) {
    const { children } = props;

    const [ isCreateDirectoryDialogOpen, setIsCreateDirectoryDialogOpen ] = useState(false);
    const [ fileSystemNodePath, setFileSystemNodePath ] = useState([]);

    const open = (fileSystemNodePath) => {
        setFileSystemNodePath(fileSystemNodePath);
        setIsCreateDirectoryDialogOpen(true);
    }

    return (
        <CreateDirectoryDialogContext.Provider value={{ open }}>
            {children}
            <CreateDirectoryDialog open={isCreateDirectoryDialogOpen} fileSystemNodePath={fileSystemNodePath} handleCancel={() => {setIsCreateDirectoryDialogOpen(false)}}/>
        </CreateDirectoryDialogContext.Provider>
    );
}
export default CreateDirectoryDialogProvider;